import KpiCard from "./KpiCard";

export default function KpiGrid({ stats }) {
  const {
    overview = {},
    growth = {},
    health = {},
    engagement = {},
    revenue = {},
  } = stats || {};

  return (
    <div className="tw-space-y-6">
      <div className="admin-v2-soft-panel tw-p-5 lg:tw-p-6">
        <p className="admin-v2-eyebrow tw-mb-4">Overview</p>
        <div className="admin-v2-kpi-grid">
          <KpiCard title="Users" value={overview.users} />
          <KpiCard title="Enterprises" value={overview.enterprises} />
          <KpiCard title="Cardholders" value={overview.cardholders} />
          <KpiCard title="Active Cards" value={overview.activeCards} />
        </div>
      </div>

      <div className="tw-grid tw-gap-6 xl:tw-grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
        <div className="admin-v2-soft-panel tw-p-5 lg:tw-p-6">
          <p className="admin-v2-eyebrow tw-mb-4">Revenue</p>
          <div className="tw-grid tw-gap-3">
            <KpiCard
              title="Monthly Recurring Revenue"
              value={`⃁ ${overview.mrr}`}
              accent="success"
              subtitle="Active subscriptions"
            />
            <KpiCard
              title="ARPU"
              value={`⃁ ${revenue.arpu}`}
              subtitle="Avg revenue per user"
            />
          </div>
        </div>

        <div className="admin-v2-soft-panel tw-p-5 lg:tw-p-6">
          <p className="admin-v2-eyebrow tw-mb-4">Growth</p>
          <div className="admin-v2-stretch-grid">
            <KpiCard title="New Users (30d)" value={growth.newUsers30d} trend={12} accent="info" />
            <KpiCard title="New Enterprises" value={growth.newEnterprises30d} />
            <KpiCard title="Card Growth Rate" value={`${growth.cardGrowthRate}%`} trend={growth.cardGrowthRate} />
          </div>
        </div>
      </div>

      <div className="tw-grid tw-gap-6 xl:tw-grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)]">
        <div className="admin-v2-soft-panel tw-p-5 lg:tw-p-6">
          <p className="admin-v2-eyebrow tw-mb-4">Health</p>
          <div className="admin-v2-stretch-grid">
            <KpiCard title="Churn Rate" value={`${health.churnRate}%`} accent="danger" />
            <KpiCard title="Expired Cards" value={health.expiredCards} />
            <KpiCard
              title="Expiring Soon (7d)"
              value={health.expiringSoon}
              accent={health.expiringSoon > 0 ? "danger" : "neutral"}
            />
          </div>
        </div>

        <div className="admin-v2-soft-panel tw-p-5 lg:tw-p-6">
          <p className="admin-v2-eyebrow tw-mb-4">Engagement</p>
          <div className="tw-grid tw-gap-3">
            <KpiCard title="Cards / Enterprise" value={engagement.cardsPerEnterprise} />
            <KpiCard title="Users / Enterprise" value={engagement.usersPerEnterprise} />
          </div>
        </div>
      </div>
    </div>
  );
}
